var StringHelper = /** @class */ (function () {
    function StringHelper() {
    }
    StringHelper.parseInt = function (value) {
        return typeof value === 'string' ? parseInt(value) : value;
    };
    StringHelper.limitLength = function (word, limit) {
        if (word.length <= limit) {
            return word;
        }
        return word.substr(0, (limit - 3)) + '...';
    };
    return StringHelper;
}());
export default StringHelper;
